module.exports = __webpack_public_path__ + "static/rome@2x.c81cacc8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2x/rome@2x.jpg
// module id = 496
// module chunks = 265343770855089